import { useState, useEffect } from 'react';
import { helpSendRequest, sendRequestFile } from '../helpers/helpSendRequest';
import moment from 'moment';
import { decrypt } from 'utils/utils';

export const useFetchData = () => {
  const [product, setProduct] = useState(process.env.REACT_APP_PRODUCT);
  const [tokenInfo, setTokenInfo] = useState({});
  const [returnButton, setReturnButton] = useState(true);
  const [price, setPrice] = useState('');
  const [isValidPerson, setIsValidPerson] = useState(false);
  const [priceToShow, setPriceToShow] = useState('');
  const [responseRequest, setResponsesRequest] = useState({ cotizacion: [], emision: [] });
  const [progressStep, setProgressStep] = useState([]);
  const [isSendForm, setIsSendForm] = useState(false);
  const [responseCotizacion, setResponseCotizacion] = useState({});
  const [folio, setFolio] = useState('');
  const [homePageData, setHomePageData] = useState({});
  const [showHomePage, setShowHomePage] = useState(true);
  const [modality, setModality] = useState("");
  const [selectedPeriodicity, setSelectedPeriodicity] = useState(12);
  const [currency, setCurrency] = useState(true);
  const [dataForm, setDataForm] = useState({
    data: {},
    message: '',
    key: '',
    formResponses: [],
    hiddenFields: [],
    disabledFields: {},
    model: {}
  });

  const [formStatus, setFormStatus] = useState({
    steps: [],
    currentStep: 0,
    currentQuestion: 0,
    numberQuestionsStep: 0,
    isGoToBack: false
  });
  const [showFinalMessage, setShowFinalMessage] = useState({ visible: false, title: '', message: '', number: '', visibleError: false });
  const [showAlert, setShowAlert] = useState({ messagge: '', type: '' });
  const [backgroundServiceResponse, setBackgroundServiceResponse] = useState({});
  const [skipCoverages, setSkipCoverages] = useState(false);
  const [checkOption, setCheckOption] = useState('');
  const [formValues, setFormValues] = useState({});
  const [disabledOption, setDisabledOption] = useState(false);
  const [disabledButtonContinue, setDisabledButtonContinue] = useState(false);
  const [codigoPostal, setCodigoPostal] = useState(false);
  const [loadingProcedure, setLoadingProcedure] = useState(false);
  const [loadingComponent, setLoadingComponent] = useState({ visible: true, active: false });
  const [sidebarData, setSidebarData] = useState([]);
  const [activeKey, setActiveKey] = useState({});
  const [insureds, setInsureds] = useState([]);
  const [checked, setChecked] = useState(false);
  const [isClassActive, setIsClassActive] = useState({ "0": false });
  const [isActive, setIsActive] = useState({});
  const [policyNumber, setPolicyNumber] = useState("000000");
  const [valuesMap, setValuesMap] = useState({});
  const [isActiveAditionals, setIsActiveAditionals] = useState({ TEV: true, FHM: true });
  const [additionalCoverages, setAdditionalCoverages] = useState([]);
  const [counter, setCounter] = useState(0);
  const [typePerson, setTypePerson] = useState({});


  useEffect(() => {

    const arrayMessages = [
      'Lo sentimos El RFC capturado no es válido, por favor revisa tus datos',
      'Tu RFC no coincide con los datos ingresados, por favor revisa tus datos',
      'Tu RFC no coincide con los datos ingresados, ¿estás seguro que es correcto?'
    ]
    const arrayButtons = [
      'Revisar',
      'Revisar',
      'Sí'
    ]
    const res = {
      renderMessage: { title: "Error", body: arrayMessages[counter - 1] || arrayMessages[2], button: arrayButtons[counter - 1] || arrayButtons[2] }
    }
    counter > 0 && setShowAlert(res);

  }, [counter]);

  useEffect(() => { product && requestInit() }, []);

  const getConfig = () => {
    return {
      host: process.env.REACT_APP_BACKEND,
      headers: { 'x-api-key': process.env.REACT_APP_API_KEY },
      path: `${process.env.REACT_APP_PATH}`
    }
  }

  const requestInit = async (attempts = 0) => {
    const config = getConfig();
    const paths = JSON.parse(process.env.REACT_APP_PATHS);
    let initData = {};
    let errors = false;

    if (paths && paths.length > 0) {
      const newHeadersConfig = {
        ...config.headers, Authorization: `Bearer ${await getToken()}`
      }

      const responses = await Promise.all(paths.map((path) =>
        helpSendRequest(`${config.host}${config.path}${path.key}`, newHeadersConfig, path.method, {})
      )).then(res => { return res });

      responses && responses.forEach(response => {
        if (response.tipo_estado === "exito") {
          const respuesta = response.respuesta;
          initData[respuesta.key] = respuesta;
        } else if (response.errors && response.errors.length && response.errors[0].code === '401') {
          errors = true
        }
      });

      if (errors && attempts < 3) {
        attempts = attempts + 1
        localStorage.removeItem(`token_${product}`)
        await requestInit(attempts)
      }
    }

    setDataForm({
      data: initData,
      message: 'Ok',
      key: '',
      formResponses: [],
      hiddenFields: [],
      disabledFields: {},
      model: {}
    });

  };

  const keyStatus = { W: 'cotizacion' }

  const customRequest = async (url, headers, method, body) => {
    try {
      const newHeaders = { ...headers, Authorization: `Bearer ${await getToken()}` };
      const res = await helpSendRequest(url, newHeaders, method, JSON.stringify(body));
      if (res) {
        const status = res.data && res.data.policy && res.data.policy.status;
        if (status) {
          res.fechaCreacion = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
          setResponsesRequest(responseRequestLcl => ({
            ...responseRequestLcl, [keyStatus[status]]:
              [...responseRequestLcl[keyStatus[status]], res.data]
          }));
        }
      }
      return res;
    } catch (error) { return error }
  };

  const fileRequest = async (url, headers, method, body) => {
    try {
      const newHeaders = { ...headers, Authorization: `Bearer ${await getToken()}` };
      return await sendRequestFile(url, newHeaders, method, body);
    } catch (error) { return error }
  };

  const validateRFC = async (info) => {
    const options = JSON.parse(process.env.REACT_APP_OPTIONS_VALIDATE_RFC);
    //const initParams = `?RFC=${info.rfc.toUpperCase()}&nombre=${info.name.toUpperCase()}&tipoPersona=${info.type}&fechaNacimiento=${info.birthdate}`;
    const initParams = `?RFC=${info.rfc.toUpperCase()}&nombre=${info.name.toUpperCase()}&segNombre=${info.secondName.toUpperCase()}&tipoPersona=${info.type}&fechaNacimiento=${info.birthdate}`;
    const params = `${initParams}${info.type === 'personaFisica' ? `&apePaterno=${info.surname.toUpperCase()}&apeMaterno=${info.secondSurname.toUpperCase()}` : ''}`
    const res = await customRequest(`${options.url}${params}`, options.header, options.method, {});
    if (!res || !res.success) {
      setCounter(counter < 3 ? counter + 1 : 1);
    } else {
      setCounter(0);
    }
    return res && res.success
  }


  const getToken = async () => {
    let token = JSON.parse(localStorage.getItem(`token_${product}`));
    if (!token || (token && !token.access_token) || (token && !token.dateExpires) ||
      (token && token.dateExpires && moment().isAfter(moment(token.dateExpires)))) {

      const getTokenOptions = JSON.parse(process.env.REACT_APP_OPTIONS_GET_TOKEN);
      const res = await helpSendRequest(getTokenOptions.url, getTokenOptions.header, getTokenOptions.method, {});
      if (res && res.result) {
        const tokenEncrypted = Buffer.from(res.result, 'base64').toString('utf-8');
        const tokenDecrypt = JSON.parse(decrypt(tokenEncrypted, process.env.REACT_APP_KEY_SECRET_TOKEN));
        const dateExpires = moment().add(tokenDecrypt.expires_in, 'seconds').format('YYYY-MM-DD HH:mm:ss');
        token = { ...tokenDecrypt, dateExpires };
        localStorage.setItem(`token_${product}`, JSON.stringify(token));
      }
    }
    return token && token.access_token ? token.access_token : '';
  }

  return {
    dataForm,
    formStatus,
    product,
    returnButton,
    checkOption,
    formValues,
    disabledOption,
    disabledButtonContinue,
    price,
    priceToShow,
    responseCotizacion,
    tokenInfo,
    codigoPostal,
    folio,
    selectedPeriodicity,
    showFinalMessage,
    showAlert,
    backgroundServiceResponse,
    skipCoverages,
    responseRequest,
    isSendForm,
    progressStep,
    loadingProcedure,
    homePageData,
    showHomePage,
    modality,
    loadingComponent,
    sidebarData,
    activeKey,
    insureds,
    checked,
    isClassActive,
    isActive,
    policyNumber,
    valuesMap,
    currency,
    isActiveAditionals,
    additionalCoverages,
    typePerson,
    isValidPerson,
    setIsValidPerson,
    setTypePerson,
    setAdditionalCoverages,
    setIsActiveAditionals,
    setCurrency,
    setValuesMap,
    setIsClassActive,
    setChecked,
    setActiveKey,
    setSidebarData,
    setLoadingComponent,
    customRequest,
    fileRequest,
    setProduct,
    setDataForm,
    setFormStatus,
    setReturnButton,
    setCheckOption,
    setFormValues,
    setDisabledOption,
    setDisabledButtonContinue,
    setPrice,
    setPriceToShow,
    setResponseCotizacion,
    setTokenInfo,
    setCodigoPostal,
    setFolio,
    setSelectedPeriodicity,
    setShowFinalMessage,
    setShowAlert,
    setBackgroundServiceResponse,
    setSkipCoverages,
    setHomePageData,
    setShowHomePage,
    setModality,
    setIsSendForm,
    setProgressStep,
    setResponsesRequest,
    setLoadingProcedure,
    setInsureds,
    setIsActive,
    setPolicyNumber,
    validateRFC
  };
};
